import React from "react";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import "./mobileComponentToShow.scss";
import SelectPassBar from "./selectPassBar";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import SelectPassModalFooter from "./selectPassModalFooter";
import SingleExercise from "./singleExercise";
import MobilePageHeader from "../../MobilePageComponent/header";
import { useTranslation } from "react-i18next";

interface IProps {
  ticket: Ticket;
  getSelect: () => void;
  backToDeafultView: () => void;
}

const MobileComponentToShowExercises: React.FC<IProps> = ({ ticket, getSelect, backToDeafultView }: IProps) => {
  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );
  const { t } = useTranslation();
  return (

    <div className="mobile-component" >
      <MobilePageHeader backFunction={backToDeafultView} title={t("najblizsze_rezerwacje")} />
      <SelectPassBar ticket={ticket} />
      <div className="select-pass-exercises">
        {ticket.exercises[0] && (
          <div>
            {ticket.exercises.map((exercise, index) => (
              <div key={index}>
                <SingleExercise exercise={exercise} getSelect={getSelect} />
              </div>
            ))}
          </div>
        )}
      </div>
      {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />}
    </div>

  );
};

export default MobileComponentToShowExercises;
